import React from "react";
import "./header.css";
import { useHistory } from "react-router-dom";
import Logo from "../Logo";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../store";
import { logout } from "../../store/slices/authSlice";

const Header: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch<AppDispatch>();
  const { isAuthenticated, user } = useSelector(
    (state: RootState) => state.auth,
  );

  const handleLogout = () => {
    dispatch(logout());
    history.push("/");
  };
  return (
    <header className="landing-header">
      <div
        className="brand"
        role="button"
        onClick={() => history.push("/")}
        aria-label="Home"
      >
        <Logo />
      </div>
      <nav className="nav">
        <a className="link" href="#features">
          Features
        </a>
        <a className="link" href="#how">
          How it works
        </a>
        <a className="link" href="#faq">
          FAQ
        </a>
        {isAuthenticated && user ? (
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <span className="link" style={{ cursor: "default" }}>
              {user.username}
            </span>
            <button className="btn secondary" onClick={handleLogout}>
              Logout
            </button>
          </div>
        ) : (
          <button
            className="btn secondary"
            onClick={() => history.push("/login")}
          >
            Log in
          </button>
        )}
      </nav>
    </header>
  );
};

export default Header;
